export default __webpack_public_path__ + "static/media/viber_image_2022-06-03_12-04-25-115.39d3279c.jpg";